import { SET_CURRENT_VALUES } from '../actionTypes';
import { profileActions } from '../reducer';

export default (values) => profileActions[SET_CURRENT_VALUES](values);
